import startCase from 'lodash.startcase'

export default (node) => {
  $('#hover-node-card .card-header').text(node.name)
  
  const ecommerceStoreValue = node.data.ecommerceStoreValue || ''
  const ecommerceStoreText = node.data.ecommerceStoreText || ''

  const ecommerceProductValue = node.data.ecommerceProductValue || ''
  const ecommerceProductText = node.data.ecommerceProductText || ''

  const ecommerceButtonTextValue = node.data.ecommerceButtonTextValue || ''

  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  if (! ecommerceStoreValue && ! ecommerceProductValue && ! ecommerceButtonTextValue) {
    $('#hover-node-card .card-body').html('')
  } else {
    const studlyCasedecommerceStoreText = startCase(ecommerceStoreText)
    const studlyCasedecommerceProductText = startCase(ecommerceProductText)

    let html = `<p><strong>Store:</strong> ${studlyCasedecommerceStoreText}</p>`
    html += `<p><strong>Product:</strong> ${studlyCasedecommerceProductText}</p>`
    html += `<p><strong>Buy now button text:</strong> ${ecommerceButtonTextValue}</p>`
    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    }

    $('#hover-node-card .card-body').html(html)
  }
}